module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">        \n        <div swagger-ui input=\"swaggerObject\" input-type=\"json\" validator-url=\"http://online.swagger.io/validator\" api-explorer=\"true\"></div>\n    </div>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/swagger/swagger.html
// module id = 259
// module chunks = 0